export const translations = {
  es: {
    nav: {
      howItWorks: 'Cómo funciona',
      forBusiness: 'Para negocios',
      tvScreen: 'Pantalla TV',
      multiLocation: 'Multi-sede',
      prizes: 'Premios',
      demo: 'Demo',
      requestDemo: 'VER DEMO EN VIVO',
      admin: 'Admin',
    },
    hero: {
      badge: 'Fan Engagement Platform',
      h1_line1: 'Tus clientes no solo ven el partido.',
      h1_highlight: 'Lo juegan contigo.',
      subtitle: 'Activa predicciones deportivas en tu negocio con QR, rankings en vivo, premios, captura de clientes y pantallas TV en tiempo real.',
      body: 'Convierte cada partido en una experiencia interactiva que aumenta visitas, permanencia, consumo y fidelización.',
      cta1: 'VER DEMO EN VIVO',
      cta2: 'Así Funciona',
      stat1: 'QR en segundos',
      stat2: 'Ranking en vivo',
      stat3: 'Multi-sede',
      stat4: 'Sin descargar app',
    },
    showcase: {
      badge: 'El producto en acción',
      title: 'Una experiencia completa para tu negocio y tus clientes',
      subtitle: 'De la pantalla TV al celular del cliente, MatchPool.live conecta cada partido con tu comunidad.',
      lbl1: 'Pronóstico en celular',
      lbl2: 'Pantalla TV en vivo',
      lbl3: 'Ambiente del negocio',
    },
    features: {
      title: 'Todo lo que necesitas para activar tu negocio',
      items: [
        { title: 'QR de participación', text: 'Tus clientes escanean y pronostican en segundos desde su celular.' },
        { title: 'Pantalla TV en vivo', text: 'Ranking en tiempo real para mostrar en televisores del local.' },
        { title: 'Captura de clientes', text: 'Nombre, teléfono, email, equipo favorito y consentimiento de marketing.' },
        { title: 'Premios del negocio', text: 'Define premios presenciales, online, por sede o por partido.' },
        { title: 'Ranking inteligente', text: 'Puntos por marcador, resultado, primer gol, tarjetas y más.' },
        { title: 'Modo híbrido', text: 'Participación presencial con código de sede y participación online desde redes.' },
      ],
    },
    howItWorks: {
      title: 'Conecta, pronostica, compite y gana.',
      subtitle: 'Una experiencia simple para el cliente y poderosa para el negocio.',
      noApp: 'Sin descargar apps. Todo funciona desde el navegador.',
      steps: [
        { num: '01', title: 'Escanea el QR', text: 'El cliente escanea el código desde una mesa, mostrador, pantalla TV o material promocional.' },
        { num: '02', title: 'Se registra', text: 'Ingresa sus datos básicos y queda conectado a la campaña del negocio.' },
        { num: '03', title: 'Pronostica', text: 'Predice marcador, ganador, primer gol, tarjetas y momentos clave del partido.' },
        { num: '04', title: 'Compite en vivo', text: 'Su puntaje se actualiza y aparece en el ranking del negocio.' },
        { num: '05', title: 'Gana premios', text: 'El negocio entrega premios, cupones o beneficios para motivar consumo y retorno.' },
      ],
    },
    benefits: {
      title: 'No solo transmitas el partido.',
      titleHighlight: 'Haz que lo jueguen.',
      body: 'Muchos negocios ponen los partidos en pantalla, pero la mayoría de los clientes solo mira y se va. Con MatchPool.live, cada partido se convierte en una dinámica participativa: el cliente escanea un QR, registra su pronóstico, compite en el ranking, ve su posición en pantalla y tiene una razón para quedarse, consumir y regresar.',
      passiveTitle: 'Experiencia pasiva',
      passiveItems: ['Cliente solo viendo el partido', 'Baja interacción', 'Sin datos', 'Sin retorno medible'],
      activeTitle: 'Participación activa',
      activeItems: ['Cliente escanea QR', 'Pronostica', 'Compite', 'Consume', 'Regresa'],
      kpis: [
        { label: 'Más tráfico', desc: 'Los partidos se convierten en excusa para atraer clientes en horarios clave.' },
        { label: 'Mayor permanencia', desc: 'El ranking y el cierre de registros mantienen la atención durante todo el partido.' },
        { label: 'Más consumo', desc: 'La participación, el compartir y esperar resultados aumentan las oportunidades de consumo.' },
        { label: 'Datos de valor', desc: 'Cada participación le ayuda al negocio a construir su propia base de clientes reales.' },
      ],
    },
    tvScreen: {
      title: 'Tu pantalla se convierte en el centro de la competencia.',
      body: 'MatchPool.live incluye una vista especial para televisores dentro del negocio. Esta pantalla muestra el partido activo, QR de participación, ranking en vivo, premio del partido y próximos encuentros.',
      cta: 'Convierte tu TV en una herramienta de participación.',
      features: ['QR gigante visible desde mesas', 'Ranking en vivo', 'Premio destacado del partido', 'Próximos partidos', 'Estado del registro', 'Actualización automática'],
    },
    mobileApp: {
      title: 'El estadio en el bolsillo de tus clientes.',
      body: 'Cada cliente participa desde su celular sin descargar aplicaciones. La experiencia funciona desde el navegador, con una interfaz rápida, visual y fácil de usar.',
      features: ['Pronósticos por partido', 'Marcador final', 'Primer gol', 'Tarjetas', 'Penales', 'Desempates', 'Edición antes del cierre', 'Ranking personal', 'Experiencia con marca del negocio'],
      note: 'El usuario puede editar su pronóstico mientras el cierre de registros siga abierto. Una vez cerrado, la predicción queda bloqueada.',
    },
    businessTypes: {
      title: 'Diseñado para restaurantes, panaderías, cafés, bares deportivos y negocios con comunidad.',
      body: 'MatchPool.live está pensado para negocios físicos que quieren aprovechar los grandes eventos deportivos para atraer clientes, generar ambiente, capturar datos y crear dinámicas de regreso.',
      types: [
        { type: 'Restaurantes', desc: 'Aumenta reservas, consumo y permanencia durante partidos.' },
        { type: 'Panaderías y cafés', desc: 'Convierte horarios de bajo tráfico en momentos de encuentro.' },
        { type: 'Sports bars', desc: 'Lleva la experiencia del partido a otro nivel competitivo.' },
        { type: 'Food halls', desc: 'Activa comunidades alrededor de varias marcas.' },
        { type: 'Cadenas multi-sede', desc: 'Compara sedes, mide participación y activa premios segmentados.' },
      ],
    },
    hybrid: {
      title: 'Participación presencial y online en una sola campaña.',
      body: 'MatchPool.live permite activar clientes dentro del local y también atraer participantes desde redes sociales, campañas digitales o enlaces compartidos.',
      colModality: 'Modalidad',
      colHow: 'Cómo participa',
      colBenefit: 'Beneficio para el negocio',
      rows: [
        { modality: 'Presencial', how: 'Escanea QR en el local', benefit: 'Aumenta visitas y consumo inmediato' },
        { modality: 'Online', how: 'Entra desde enlace o redes', benefit: 'Captura leads y genera retorno' },
        { modality: 'Multi-sede', how: 'Elige o valida ubicación', benefit: 'Mide rendimiento por sede' },
        { modality: 'Evento especial', how: 'Participa por premio del partido', benefit: 'Crea urgencia y emoción' },
      ],
      note: 'Los premios son definidos por cada negocio. No hay apuestas ni dinero de por medio.',
    },
    multiLocation: {
      title: 'Una plataforma para muchas sedes.',
      titleHighlight: 'Una sola comunidad.',
      body: 'Para marcas con varias ubicaciones, MatchPool.live permite centralizar la campaña y medir participación por sede, ciudad o comunidad.',
      support: 'Cada sede puede tener su propio QR, ranking, premio y actividad, mientras la marca conserva una visión global del desempeño.',
      cards: [
        { title: 'Métricas por ubicación', desc: 'Identifica qué sedes generan más participación.' },
        { title: 'Rankings por sede', desc: 'Cada local puede tener su propia competencia.' },
        { title: 'Ranking global', desc: 'La marca puede activar una competencia general.' },
        { title: 'Premios segmentados', desc: 'Cada sede puede ofrecer beneficios diferenciados.' },
        { title: 'Reportes centralizados', desc: 'Analiza leads y comportamiento por sede.' },
      ],
    },
    prizes: {
      title: 'Premios simples que generan acción.',
      body: 'El negocio define qué quiere entregar: desayunos, gift cards, cafés, combos, descuentos, experiencias o productos patrocinados.',
      types: [
        { title: 'Premio por partido', desc: 'Ideal para activación de consumo inmediato.' },
        { title: 'Premio semanal', desc: 'Motiva la participación recurrente.' },
        { title: 'Premio por sede', desc: 'Activa comunidades locales.' },
        { title: 'Premio para top 3', desc: 'Activa podio completo con oro, plata y bronce.' },
        { title: 'Cupones de retorno', desc: 'Convierte la emoción del partido en motivo de próxima visita.' },
      ],
      podium: 'Puedes premiar solo al primer lugar o activar un podio completo con oro, plata y bronce.',
      disclaimer: 'Sin apuestas. Sin dinero de por medio. Solo fan engagement, premios del negocio y participación promocional.',
    },
    data: {
      title: 'De fans anónimos a base de datos propia.',
      body: 'Cada partido puede convertirse en una oportunidad para conocer mejor a tus clientes.',
      fields: ['Nombre', 'Teléfono', 'Email', 'Sede favorita', 'Equipo favorito', 'Historial de participación', 'Consentimiento de marketing', 'Intereses deportivos'],
      commercial: 'Después del evento, esa base de datos puede usarse para campañas de remarketing, SMS, promociones de temporada, eventos especiales y programas de fidelización.',
    },
    roi: {
      title: 'Más que entretenimiento:',
      titleHighlight: 'una estrategia para llenar mesas.',
      body: 'MatchPool.live ayuda a convertir los partidos en una herramienta comercial medible.',
      headline: 'No solo llenes pantallas. Llena mesas.',
      steps: [
        { num: '1', title: 'El partido atrae atención', desc: 'El evento deportivo genera interés natural.' },
        { num: '2', title: 'El QR convierte espectadores', desc: 'Los clientes pasan de ver a jugar.' },
        { num: '3', title: 'El ranking mantiene la emoción', desc: 'La competencia sostiene la atención.' },
        { num: '4', title: 'El premio incentiva consumo', desc: 'El negocio convierte participación en acción comercial.' },
        { num: '5', title: 'La base de datos queda', desc: 'El valor continúa después del partido.' },
      ],
    },
    implementation: {
      title: 'De la configuración al lanzamiento en pocos días.',
      body: 'MatchPool.live puede activarse rápidamente para campañas deportivas, torneos, partidos especiales o temporadas completas.',
      cta: 'VER DEMO EN VIVO',
      days: [
        { day: 'Día 1', label: 'Kickoff', desc: 'Definición de negocio, sedes, objetivos y premios.' },
        { day: 'Día 2', label: 'Configuración', desc: 'Creación del tenant, branding, QR y estructura inicial.' },
        { day: 'Día 3', label: 'Vista TV', desc: 'Preparación de pantalla para local o sede principal.' },
        { day: 'Día 4', label: 'Pruebas', desc: 'Validación de QR, registro, pronósticos y ranking.' },
        { day: 'Día 5', label: 'Lanzamiento', desc: 'Activación comercial con clientes, redes y material físico.' },
      ],
    },
    useCases: {
      title: 'Campañas listas para activar durante la temporada futbolera.',
      cases: [
        { title: 'Mundial 2026', desc: 'Pronósticos diarios, rankings por sede, premios por partido y comunidad activa durante toda la temporada.' },
        { title: 'Copa América', desc: 'Activaciones por país, selección favorita y partidos clave.' },
        { title: 'Champions League', desc: 'Eventos recurrentes para restaurantes, bares y cafés.' },
        { title: 'Finales y clásicos', desc: 'Experiencias especiales para partidos de alta audiencia.' },
        { title: 'Torneos locales', desc: 'Activaciones para ligas comunitarias, academias, colegios o clubes.' },
      ],
    },
    plans: {
      title: 'Activa MatchPool.live en tu negocio.',
      subtitle: 'Activa MatchPool.live y convierte cada partido en una experiencia interactiva. Tus clientes escanean un QR, hacen pronósticos, compiten en rankings en vivo y participan por premios, mientras tu marca captura datos y genera comunidad.',
      perCampaign: 'por campaña / torneo',
      recommended: 'Recomendado',
      customTitle: '¿Tienes más de 5 sedes?',
      customText: 'Tenemos propuestas personalizadas para cadenas con más sedes de los planes anteriores. Escríbenos.',
      customCta: 'Solicitar propuesta personalizada',
      tiers: [
        {
          name: 'MatchPool Business',
          price: '$699',
          originalPrice: '$999',
          discount: 'Ahorra $300',
          sedes: '1 sede',
          sms: '',
          paymentUrl: 'https://buy.stripe.com/9B69AUacne67abn3V75Rm08',
          desc: 'Ideal para negocios que quieren activar MatchPool.live durante un Mundial o torneo específico, capturar clientes y generar engagement básico con una experiencia profesional.',
          cta: 'Activar por $699',
          features: [
            '1 sede activada',
            'QR de participación',
            'Pronósticos diarios por partido',
            'Ranking en vivo',
            'Pantalla TV premium incluida',
            'Captura de datos de participantes',
            'Consentimiento para comunicaciones futuras',
            'Exportación básica de datos',
            'Branding básico con logo del negocio',
            'Premio configurable por el negocio',
            'Soporte de configuración inicial',
          ],
        },
        {
          name: 'MatchPool Fan Engagement System',
          price: '$2,500',
          sedes: 'Hasta 3 sedes',
          sms: '2,500 SMS incluidos',
          badge: 'Recomendado',
          collectSticker: 'Incluye CollectSticker.club como fase pre-Mundial',
          desc: 'Ideal para negocios que quieren una experiencia más completa antes y durante el Mundial, combinando comunidad coleccionista, tráfico pre-torneo y activación en partido.',
          cta: 'Activar por $2,500',
          features: [
            'Todo lo del plan Business',
            'Hasta 3 sedes activadas',
            'QR por sede',
            'Ranking por sede + ranking general',
            'Integración con CollectSticker.club',
            'Activación de comunidad coleccionista',
            'Eventos de intercambio conectados a la campaña',
            'Segmentación básica por sede',
            'Kit visual básico para puntos de venta',
            'Soporte de activación',
            '2,500 SMS incluidos',
            'Pantalla TV premium para todas las sedes',
          ],
        },
        {
          name: 'MatchPool Multi-Sede Premium',
          price: '$3,500',
          sedes: 'Hasta 5 sedes',
          sms: '5,000 SMS incluidos',
          addOn: 'Sedes adicionales desde $500',
          desc: 'Ideal para cadenas o grupos con múltiples ubicaciones que buscan una campaña robusta con reportes, personalización avanzada y mayor capacidad de comunicación.',
          cta: 'Activar por $3,500',
          features: [
            'Todo lo del Fan Engagement System',
            'Hasta 5 sedes activadas',
            'Sedes adicionales desde $500',
            'Mayor personalización visual',
            'Mensajes personalizados por sede',
            'Ranking global de marca + por sede',
            'Reportes segmentados por sede',
            'Exportación avanzada de datos',
            'Kit visual expandido (redes, pantallas, POS)',
            'Soporte de activación prioritario',
            'Premio por sede o general',
            '5,000 SMS incluidos',
          ],
        },
      ],
    },
    faq: {
      title: 'Preguntas frecuentes',
      items: [
        { q: '¿MatchPool.live es una plataforma de apuestas?', a: 'No. MatchPool.live no maneja apuestas, dinero entre usuarios ni juegos de azar. Es una plataforma promocional de predicciones, rankings y premios definidos por el negocio.' },
        { q: '¿El cliente necesita descargar una app?', a: 'No. El cliente participa desde el navegador escaneando un QR.' },
        { q: '¿El negocio debe actualizar resultados manualmente?', a: 'No necesariamente. La plataforma base puede centralizar programación, resultados y datos del torneo para alimentar las campañas de los negocios participantes.' },
        { q: '¿Se puede usar en varias sedes?', a: 'Sí. Cada sede puede tener su propio QR, ranking, premio y métricas, mientras la marca conserva una vista global.' },
        { q: '¿Qué premios puede ofrecer el negocio?', a: 'Gift cards, desayunos, cafés, combos, descuentos, productos, experiencias o beneficios patrocinados.' },
        { q: '¿Se puede mostrar en una TV del local?', a: 'Sí. MatchPool.live incluye una vista TV diseñada para mostrar QR, ranking, premio, partido activo y próximos encuentros.' },
      ],
    },
    finalCta: {
      title1: 'No solo llenes pantallas.',
      title2: 'Llena mesas.',
      subtitle: 'Convierte cada partido en una experiencia que tus clientes jueguen, compartan y quieran repetir.',
      cta1: 'VER DEMO EN VIVO',
      cta2: 'Quiero activar mi negocio',
    },
    footer: {
      tagline: 'Sistema visual y comercial para SaaS de pronósticos deportivos y fan engagement.',
      links: ['Cómo funciona', 'Para negocios', 'Pantalla TV', 'Demo', 'Admin'],
      legal: 'MatchPool.live es una plataforma promocional de predicciones y fan engagement. No es una plataforma de apuestas.',
      rights: '© 2026 MatchPool.live by GOL.SOCIAL. Todos los derechos reservados.',
    },
    modal: {
      title: 'Activa tu negocio',
      subtitle: 'Completa el formulario y te contactaremos para mostrarte cómo activar MatchPool.live en tu negocio.',
      fields: {
        name: 'Nombre completo',
        business: 'Nombre del negocio',
        city: 'Ciudad',
        type: 'Tipo de negocio',
        locations: 'Número de sedes',
        phone: 'Teléfono',
        email: 'Email',
        message: 'Mensaje (opcional)',
      },
      types: ['Restaurante', 'Panadería / Café', 'Sports bar', 'Food hall', 'Cadena multi-sede', 'Otro'],
      cta: 'Aplicar ahora',
      success: 'Gracias. Revisaremos tu solicitud y te contactaremos para mostrarte cómo activar MatchPool.live en tu negocio.',
      close: 'Cerrar',
    },
  },
  en: {
    nav: {
      howItWorks: 'How it works',
      forBusiness: 'For businesses',
      tvScreen: 'TV Screen',
      multiLocation: 'Multi-location',
      prizes: 'Prizes',
      demo: 'Demo',
      requestDemo: 'SEE LIVE DEMO',
      admin: 'Admin',
    },
    hero: {
      badge: 'Fan Engagement Platform',
      h1_line1: 'Your customers don\'t just watch the game.',
      h1_highlight: 'They play it with you.',
      subtitle: 'Activate sports predictions in your business with QR codes, live rankings, prizes, customer capture, and real-time TV screens.',
      body: 'Turn every game into an interactive experience that increases visits, dwell time, consumption, and loyalty.',
      cta1: 'SEE LIVE DEMO',
      cta2: 'How It Works',
      stat1: 'QR in seconds',
      stat2: 'Live ranking',
      stat3: 'Multi-location',
      stat4: 'No app download',
    },
    showcase: {
      badge: 'Product in action',
      title: 'A complete experience for your business and your customers',
      subtitle: 'From the TV screen to the customer\'s phone, MatchPool.live connects every game with your community.',
      lbl1: 'Mobile prediction',
      lbl2: 'Live TV screen',
      lbl3: 'Business environment',
    },
    features: {
      title: 'Everything you need to activate your business',
      items: [
        { title: 'QR participation', text: 'Your customers scan and predict in seconds from their phone.' },
        { title: 'Live TV screen', text: 'Real-time ranking to display on venue TVs.' },
        { title: 'Customer capture', text: 'Name, phone, email, favorite team, and marketing consent.' },
        { title: 'Business prizes', text: 'Define in-person prizes, online, by location, or by match.' },
        { title: 'Smart ranking', text: 'Points for score, result, first goal, cards, and more.' },
        { title: 'Hybrid mode', text: 'In-person participation with location code and online participation from social media.' },
      ],
    },
    howItWorks: {
      title: 'Connect, predict, compete, and win.',
      subtitle: 'A simple experience for the customer and powerful for the business.',
      noApp: 'No app download needed. Everything works from the browser.',
      steps: [
        { num: '01', title: 'Scan the QR', text: 'The customer scans the code from a table, counter, TV screen, or promotional material.' },
        { num: '02', title: 'Register', text: 'Enters basic data and connects to the business\'s campaign.' },
        { num: '03', title: 'Predict', text: 'Predicts score, winner, first goal, cards, and key match moments.' },
        { num: '04', title: 'Compete live', text: 'Their score updates and appears on the business ranking.' },
        { num: '05', title: 'Win prizes', text: 'The business delivers prizes, coupons, or benefits to incentivize consumption and return.' },
      ],
    },
    benefits: {
      title: 'Don\'t just broadcast the game.',
      titleHighlight: 'Make them play it.',
      body: 'Many businesses put games on screen, but most customers just watch and leave. With MatchPool.live, every game becomes an interactive dynamic: the customer scans a QR, registers their prediction, competes in the ranking, sees their position on screen, and has a reason to stay, consume, and come back.',
      passiveTitle: 'Passive experience',
      passiveItems: ['Customer just watching the game', 'Low interaction', 'No data', 'No measurable return'],
      activeTitle: 'Active participation',
      activeItems: ['Customer scans QR', 'Predicts', 'Competes', 'Consumes', 'Returns'],
      kpis: [
        { label: 'More traffic', desc: 'Games become a reason to attract customers during key hours.' },
        { label: 'More dwell time', desc: 'Rankings and registration closings keep attention throughout the game.' },
        { label: 'More consumption', desc: 'Participation, sharing, and waiting for results increase consumption.' },
        { label: 'Valuable data', desc: 'Every participation helps the business build its own real customer database.' },
      ],
    },
    tvScreen: {
      title: 'Your screen becomes the center of competition.',
      body: 'MatchPool.live includes a special view for venue TVs. This screen shows the active game, participation QR, live ranking, match prize, and upcoming matches.',
      cta: 'Turn your TV into a participation tool.',
      features: ['Giant QR visible from tables', 'Live ranking', 'Featured match prize', 'Upcoming games', 'Registration status', 'Automatic update'],
    },
    mobileApp: {
      title: 'The stadium in your customers\' pocket.',
      body: 'Each customer participates from their phone without downloading apps. The experience works from the browser with a fast, visual, and easy-to-use interface.',
      features: ['Predictions per match', 'Final score', 'First goal', 'Cards', 'Penalties', 'Tiebreakers', 'Edit before closing', 'Personal ranking', 'Business-branded experience'],
      note: 'Users can edit their prediction while registration is open. Once closed, the prediction is locked.',
    },
    businessTypes: {
      title: 'Designed for restaurants, bakeries, cafes, sports bars, and community businesses.',
      body: 'MatchPool.live is designed for physical businesses that want to leverage major sporting events to attract customers, create atmosphere, capture data, and drive return visits.',
      types: [
        { type: 'Restaurants', desc: 'Increase reservations, consumption, and dwell time during games.' },
        { type: 'Bakeries & cafes', desc: 'Turn low-traffic hours into community moments.' },
        { type: 'Sports bars', desc: 'Take the game experience to another competitive level.' },
        { type: 'Food halls', desc: 'Activate communities around multiple brands.' },
        { type: 'Multi-location chains', desc: 'Compare venues, measure participation, and activate segmented prizes.' },
      ],
    },
    hybrid: {
      title: 'In-person and online participation in a single campaign.',
      body: 'MatchPool.live lets you activate customers inside the venue and also attract participants from social media, digital campaigns, or shared links.',
      colModality: 'Modality',
      colHow: 'How they participate',
      colBenefit: 'Business benefit',
      rows: [
        { modality: 'In-person', how: 'Scan QR at the venue', benefit: 'Increases visits and immediate consumption' },
        { modality: 'Online', how: 'Enter from link or social media', benefit: 'Captures leads and drives return' },
        { modality: 'Multi-location', how: 'Choose or validate location', benefit: 'Measure performance by location' },
        { modality: 'Special event', how: 'Participate for match prize', benefit: 'Creates urgency and excitement' },
      ],
      note: 'Prizes are defined by each business. There are no bets or money involved.',
    },
    multiLocation: {
      title: 'One platform for many locations.',
      titleHighlight: 'One single community.',
      body: 'For brands with multiple locations, MatchPool.live centralizes campaigns and measures participation by location, city, or community.',
      support: 'Each location can have its own QR, ranking, prize, and activity, while the brand maintains a global performance view.',
      cards: [
        { title: 'Metrics by location', desc: 'Identify which venues generate more participation.' },
        { title: 'Rankings by location', desc: 'Each venue can have its own competition.' },
        { title: 'Global ranking', desc: 'The brand can activate a general competition.' },
        { title: 'Segmented prizes', desc: 'Each location can offer different benefits.' },
        { title: 'Centralized reports', desc: 'Analyze leads and behavior by location.' },
      ],
    },
    prizes: {
      title: 'Simple prizes that generate action.',
      body: 'The business defines what to deliver: breakfasts, gift cards, coffees, combos, discounts, experiences, or sponsored products.',
      types: [
        { title: 'Prize per match', desc: 'Ideal for immediate consumption activation.' },
        { title: 'Weekly prize', desc: 'Motivates recurring participation.' },
        { title: 'Prize by location', desc: 'Activates local communities.' },
        { title: 'Prize for top 3', desc: 'Activates a full gold, silver, and bronze podium.' },
        { title: 'Return coupons', desc: 'Turns game excitement into a reason for a next visit.' },
      ],
      podium: 'You can reward only first place or activate a full podium with gold, silver, and bronze.',
      disclaimer: 'No betting. No money involved. Just fan engagement, business prizes, and promotional participation.',
    },
    data: {
      title: 'From anonymous fans to your own database.',
      body: 'Every game can become an opportunity to better understand your customers.',
      fields: ['Name', 'Phone', 'Email', 'Favorite location', 'Favorite team', 'Participation history', 'Marketing consent', 'Sports interests'],
      commercial: 'After the event, that database can be used for remarketing campaigns, SMS, seasonal promotions, special events, and loyalty programs.',
    },
    roi: {
      title: 'More than entertainment:',
      titleHighlight: 'a strategy to fill tables.',
      body: 'MatchPool.live helps turn games into a measurable commercial tool.',
      headline: 'Don\'t just fill screens. Fill tables.',
      steps: [
        { num: '1', title: 'The game attracts attention', desc: 'The sporting event generates natural interest.' },
        { num: '2', title: 'The QR converts spectators', desc: 'Customers shift from watching to playing.' },
        { num: '3', title: 'The ranking keeps excitement', desc: 'Competition sustains attention throughout.' },
        { num: '4', title: 'The prize incentivizes consumption', desc: 'The business converts participation into commercial action.' },
        { num: '5', title: 'The database remains', desc: 'Value continues after the game.' },
      ],
    },
    implementation: {
      title: 'From setup to launch in a few days.',
      body: 'MatchPool.live can be quickly activated for sports campaigns, tournaments, special games, or full seasons.',
      cta: 'SEE LIVE DEMO',
      days: [
        { day: 'Day 1', label: 'Kickoff', desc: 'Define business, locations, objectives, and prizes.' },
        { day: 'Day 2', label: 'Setup', desc: 'Create tenant, branding, QR, and initial structure.' },
        { day: 'Day 3', label: 'TV View', desc: 'Prepare the screen for the venue or main location.' },
        { day: 'Day 4', label: 'Testing', desc: 'Validate QR, registration, predictions, and ranking.' },
        { day: 'Day 5', label: 'Launch', desc: 'Commercial activation with customers, social media, and physical materials.' },
      ],
    },
    useCases: {
      title: 'Ready-to-activate campaigns during the football season.',
      cases: [
        { title: 'World Cup 2026', desc: 'Daily predictions, per-location rankings, per-game prizes, and active community throughout the season.' },
        { title: 'Copa América', desc: 'Activations by country, favorite team, and key matches.' },
        { title: 'Champions League', desc: 'Recurring events for restaurants, bars, and cafes.' },
        { title: 'Finals & classics', desc: 'Special experiences for high-audience games.' },
        { title: 'Local tournaments', desc: 'Activations for community leagues, academies, schools, or clubs.' },
      ],
    },
    plans: {
      title: 'Activate MatchPool.live in your business.',
      subtitle: 'Activate MatchPool.live and turn every match into an interactive experience. Your customers scan a QR, make predictions, compete in live rankings, and participate for prizes, while your brand captures data and builds community.',
      perCampaign: 'per campaign / tournament',
      recommended: 'Recommended',
      customTitle: 'More than 5 locations?',
      customText: 'We have customized proposals for chains with more locations than the plans above. Contact us.',
      customCta: 'Request custom proposal',
      tiers: [
        {
          name: 'MatchPool Business',
          price: '$699',
          originalPrice: '$999',
          discount: 'Save $300',
          sedes: '1 location',
          sms: '',
          paymentUrl: 'https://buy.stripe.com/9B69AUacne67abn3V75Rm08',
          desc: 'Ideal for businesses that want to activate MatchPool.live during a World Cup or specific tournament, capture clients, and generate basic engagement with a professional experience.',
          cta: 'Activate for $699',
          features: [
            '1 activated location',
            'Participation QR',
            'Daily predictions per match',
            'Live ranking',
            'Premium TV screen included',
            'Participant data capture',
            'Consent for future communications',
            'Basic data export',
            'Basic branding with business logo',
            'Business-configurable prize',
            'Initial setup support',
          ],
        },
        {
          name: 'MatchPool Fan Engagement System',
          price: '$2,500',
          sedes: 'Up to 3 locations',
          sms: '2,500 SMS included',
          badge: 'Recommended',
          collectSticker: 'Includes CollectSticker.club as pre-World Cup phase',
          desc: 'Ideal for businesses that want a more complete experience before and during the World Cup, combining a collector community, pre-tournament traffic, and in-game activation.',
          cta: 'Activate for $2,500',
          features: [
            'Everything in Business plan',
            'Up to 3 activated locations',
            'QR per location',
            'Ranking per location + global ranking',
            'CollectSticker.club integration',
            'Collector community activation',
            'Exchange events connected to campaign',
            'Basic segmentation by location',
            'Basic visual kit for POS',
            'Activation support',
            '2,500 SMS included',
            'Premium TV screen for all active locations',
          ],
        },
        {
          name: 'MatchPool Multi-Location Premium',
          price: '$3,500',
          sedes: 'Up to 5 locations',
          sms: '5,000 SMS included',
          addOn: 'Additional locations from $500',
          desc: 'Ideal for chains or groups with multiple locations seeking a robust campaign with reports, advanced customization, and greater communication capacity.',
          cta: 'Activate for $3,500',
          features: [
            'Everything in Fan Engagement System',
            'Up to 5 activated locations',
            'Additional locations from $500',
            'Greater visual customization',
            'Personalized messages per location',
            'Global brand ranking + per location',
            'Segmented reports by location',
            'Advanced data export',
            'Expanded visual kit (social, screens, POS)',
            'Priority activation support',
            'Prize per location or general',
            '5,000 SMS included',
          ],
        },
      ],
    },
    faq: {
      title: 'Frequently asked questions',
      items: [
        { q: 'Is MatchPool.live a betting platform?', a: 'No. MatchPool.live does not handle bets, money between users, or gambling. It is a promotional platform for predictions, rankings, and prizes defined by the business.' },
        { q: 'Does the customer need to download an app?', a: 'No. The customer participates from the browser by scanning a QR code.' },
        { q: 'Does the business need to update results manually?', a: 'Not necessarily. The base platform can centralize tournament programming, results, and data to feed business campaigns.' },
        { q: 'Can it be used in multiple locations?', a: 'Yes. Each location can have its own QR, ranking, prize, and metrics, while the brand maintains a global view.' },
        { q: 'What prizes can the business offer?', a: 'Gift cards, breakfasts, coffees, combos, discounts, products, experiences, or sponsored benefits.' },
        { q: 'Can it be shown on a venue TV?', a: 'Yes. MatchPool.live includes a TV view designed to show QR, ranking, prize, active game, and upcoming matches.' },
      ],
    },
    finalCta: {
      title1: 'Don\'t just fill screens.',
      title2: 'Fill tables.',
      subtitle: 'Turn every game into an experience your customers will play, share, and want to repeat.',
      cta1: 'SEE LIVE DEMO',
      cta2: 'I want to activate my business',
    },
    footer: {
      tagline: 'Visual and commercial system for sports prediction SaaS and fan engagement.',
      links: ['How it works', 'For businesses', 'TV screen', 'Demo', 'Admin'],
      legal: 'MatchPool.live is a promotional platform for predictions and fan engagement. It is not a betting platform.',
      rights: '© 2026 MatchPool.live by GOL.SOCIAL. All rights reserved.',
    },
    modal: {
      title: 'Activate my business',
      subtitle: 'Complete the form and we\'ll contact you to show you how to activate MatchPool.live in your business.',
      fields: {
        name: 'Full name',
        business: 'Business name',
        city: 'City',
        type: 'Business type',
        locations: 'Number of locations',
        phone: 'Phone',
        email: 'Email',
        message: 'Message (optional)',
      },
      types: ['Restaurant', 'Bakery / Café', 'Sports bar', 'Food hall', 'Multi-location chain', 'Other'],
      cta: 'Apply now',
      success: 'Thank you. We will review your request and contact you to show you how to activate MatchPool.live in your business.',
      close: 'Close',
    },
  },
};
